import configData from "@/config/config";
import { getNoticerSummary } from "@/api/api-basic";
const state = {
    noticeCount: 0,
    noticeUnreadList: [],
    alarmLevelStat: [],
    alarmTotalCount: 0,
    alarmLever: "",
};
const getters = {};
const mutations = {
    /**
     * 平台消息
     * @param state
     * @param data 接口数据
     */
    SET_NOTICE(state, data) {
        state.noticeCount = data.noticeCount;
        state.noticeUnreadList = data.noticeList || [];
    },
    /**
     * 告警消息和列表
     * @param state
     * @param data 接口数据
     */
    SET_ALARM(state, data) {
        state.alarmTotalCount = data.totalCount;
        state.alarmLevelStat = data.alarmLevelStat || [];
    },
    /**
     * 头部告警消息点击，要刷新“事件告警”页面表格
     * @param state
     * @param lever 等级
     */
    SET_ALARMLEVER(state, lever) {
        state.alarmLever = lever;
    },
};
const actions = {
    async getNoticerSummary({ commit }) {
        const ret = await getNoticerSummary({});
        if (ret.status === configData.apiStatus) {
            commit("SET_NOTICE", ret.data[0]);
        }
    },
};
export default {
    state,
    mutations,
    actions,
    getters,
};
